import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import CATEGORY_LISTS from '../../../public/assets/constants/category';
import SubCategories, { ICategoryItem } from './SubCategories';

const Category: React.FC = () => {
  const history = useHistory();
  const splitPath = history.location.pathname.split('/');
  const categoryId = +splitPath[splitPath.length - 1];
  const [category, setCategory] = useState<ICategoryItem[]>();

  const initData = () => {
    const currentCategory = CATEGORY_LISTS[categoryId - 1];
    setCategory(currentCategory?.children);
    if (!currentCategory?.children?.length) {
      return history.replace('/');
    }
    document.title = currentCategory.name;
  };

  useEffect(() => {
    initData();
  }, []);

  return (
    <div>{category?.length && <SubCategories initialData={category} />}</div>
  );
};

export default Category;
